export default __webpack_public_path__ + "static/media/cx_cover_fsc45_t2.9ab53bdc.jpg";